import { EventBus } from '@/services/EventBus'
import IconCam from '@/components/iconCam/IconCam.vue'

export default {
    name: 'Cam',
    data () {
        return {
        }
    },
    props: {
        cam: {
            type: Object,
        },
        draggable: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        inMap: {
            type: Boolean,
            default: false
        }
    },
    methods: {
       
        dragStart() {
            if (this.selected || ! this.draggable)
                return false

            EventBus.$emit('cam:dragstart')
        },
        dragEnd() {
            EventBus.$emit('cam:dragend')
        },
        selectView(view) {
            this.$store.commit('setGrid', view.grid)
            this.$router.push({ name: 'views', params: { viewId: view.id } })
        }
    },
    components: {
        IconCam
    },
}



// WEBPACK FOOTER //
// ./src/components/cam/cam.js